import { MainFilterStateProducts } from '../../reducers/main-filter-products/MainFiltersProductsReducer';
import { MainFilterTypeProducts } from '../Type';

export const updateMainFiltersProducts = (payload: MainFilterStateProducts) => {
  return (dispatch: any) => {
    dispatch({
      type: MainFilterTypeProducts.MainFiltersUpdatedProducts,
      payload,
    });
  };
};
